const FIELDS = [
  {
    name: "name",
    label: "Name*",
    placeholder: "Name*",
  },
  {
    name: "email",
    label: "E-Mail-Adresse*",
    placeholder: "E-Mail-Adresse*",
  },
  {
    name: "phone",
    label: "Telefonnummer (optional)",
    placeholder: "Telefon",
  },
  {
    name: "message_text",
    label: "Ihre Nachricht*",
    placeholder: "Ihre Nachricht*",
  },
  {
    name: "consent",
    appearance: "small",
    label:
      "Ich habe die Datenschutzerklärung zur Kenntnis genommen und stimme zu, dass meine Daten aus dem Kontaktformular zur Beantwortung meiner Anfrage erhoben und verarbeitet werden. Die Daten werden nach abgeschlossener Bearbeitung der Anfrage gelöscht. Hinweis: Sie können Ihre Einwilligung für die Zukunft jederzeit per E-Mail an anfrage@planmaschine.de widerrufen. Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in unserer Datenschutzerklärung.",
  },
]

export default FIELDS
